import React, { Suspense } from 'react'
import {
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import useAuth from '../../lib/useAuth'
import useNotFound from '../../lib/useNotFound'
import { views, viewsArray } from '../../views'

const RouteComponent = ({ Component }) => <Component />

const Routes = () => {
  useAuth({ redirect: true })
  const pageNotFound = useNotFound()

  return (
    <Suspense fallback={null}>
      <Switch>
        <Redirect exact from='/' to='/home' />
        {!pageNotFound && viewsArray.map((viewItem) => {
          return (
            <Route key={viewItem.path} path={`/${viewItem.path}`} exact>
              <RouteComponent Component={withTranslation()(views[viewItem.path])} />
            </Route>
          )
        })}
        <Route component={views.notfound} />
      </Switch>
    </Suspense>
  )
}
export default React.memo(Routes)
